import { createContext, useContext, useEffect } from 'react';

/** Provided by the app shell: sets the sidebar link to highlight, or `null` to follow the URL. */
export const NavSectionContext = createContext<(to: string | null) => void>(() => {});

/**
 * Highlights the sidebar link to `to` while the calling page is mounted, for pages whose URL sits under another
 * section — a dealer's profile lives at /leads/:id but belongs under Dealers. `null` keeps the URL-based highlight.
 */
export function useNavSection(to: string | null): void {
  const setSection = useContext(NavSectionContext);
  useEffect(() => {
    setSection(to);
    return () => setSection(null);
  }, [setSection, to]);
}
